<section class="dashboard-header__section">
	<div id="imgContainer" data-cy="dashboard-header__logo">
		<img *ngIf="logoPath" [alt]="logoAltTag" [src]="logoPath" />
	</div>
	<div id="greetingContainer" class="h3" data-cy="dashboard-header__greeting">
		{{ 'dashboard.welcome' | locale: merchantLocaleSuffix }}
	</div>
	<p data-cy="dashboard-header__description">{{ 'dashboard.description' | locale: merchantLocaleSuffix }}</p>
</section>
